import { render, staticRenderFns } from "./HomeSwiper.vue?vue&type=template&id=388a034a&scoped=true&"
import script from "./HomeSwiper.vue?vue&type=script&lang=js&"
export * from "./HomeSwiper.vue?vue&type=script&lang=js&"
import style0 from "./HomeSwiper.vue?vue&type=style&index=0&id=388a034a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388a034a",
  null
  
)

export default component.exports